import { useAuth } from "@/context/AuthContext";

// On pages a Fully Funded Shifts support session may look at but never change (logins, roles, email senders:
// permissions.SUPPORT_READ_ONLY), in either mode. The buttons stay, but the app refuses any change.
export function SupportLookOnlyNote() {
  const { user } = useAuth();
  if (!user?.support_mode) return null;
  return (
    <p role="status" data-testid="support-look-only-note"
      className="mb-4 rounded-lg border border-amber-300 bg-amber-50 px-3 py-2 text-sm text-amber-900">
      FFS support can look at this page but not change it. Saving, deleting or sending a test from here is refused.
    </p>
  );
}
